<template lang="pug">
	#login.admin.theme-1
		section.material-half-bg
			.cover

		section.login-content
			.logo: h1 

			.login-box
				ValidationObserver(ref="ValidatorLogin" slim)
					form.login-form(@submit.prevent='onSubmit')
						h3.login-head
							i.fa.fa-lg.fa-fw.fa-user
							| SIGN IN
						.form-group
							label.control-label USERNAME
							ValidationProvider(name="Username" v-slot='{errors}' rules='required|email')
								input.form-control(type="text", placeholder="Email", autofocus v-model='username')
								//- template(v-if='errors.length')
								small.text-danger(v-for='error in errors') {{error}}

						.form-group
							label.control-label PASSWORD
							input.form-control(type="password", placeholder="Password" v-model='password')

						.form-group
							.utility
								.animated-checkbox
									label
										input(type="checkbox")
										span.label-text Stay Signed in
								p.semibold-text.mb-2
									a(href="javascript:void(0)" @click.prevent='flip') Forgot Password?

						.form-group.btn-container.text-center
							button.btn.btn-primary.btn-block(type='submit')
								i.fas.fa-sign-in-alt.fa-fw
								| &nbsp;SIGN IN
							br
							a(href='javascript:void(0);' @click.prevent='$router.push("/register")'): b No Account? Register here
							//- button.btn.btn-primary.btn-block
								i.fas.fa-sign-in-alt.fa-fw
								| &nbsp;SIGN IN
				form.forget-form(@submit.prevent="resetPassword")
					h3.login-head
						i.fa.fa-lock
						| &nbsp;Forgot Password ?
					.form-group
						label.control-label EMAIL
						input.form-control(type="text", placeholder="Email" v-model='resetEmail')

					.form-group.btn-container
						button.btn.btn-primary.btn-block
							i.fa.fa-unlock.fa-lg.fa-fw
							| RESET

					.form-group.mt-3
						p.semibold-text.mb-0
							a(href="javascript:void(0)" @click.prevent='flip') <i class="fa fa-angle-left fa-fw"></i> Back to Login
</template>

<script>
import $ from 'jquery'


export default {

	name: 'login',

	components: {
	},

	data () {
		return {
			resetEmail: '',
			username: '',
			password: '',
		}
	},
	mounted(){
		if(process.env.NODE_ENV==='development') {
			this.username= 'member@innoviders.com'
			this.password='1nn0vider5'
		}
	},

	methods: {
		/**
		 * [flip description]
		 * @return {[type]} [description]
		 */
		flip() {
			$('.login-box').toggleClass('flipped');
		},


		/**
		 * [resetPassword description]
		 * @return {[type]} [description]
		 */
		resetPassword() {
			this.$swal({
				text: 'Validating. . .',
				allowOutsideClick: false,
			})
			this.$swal.showLoading()

			this.$http.post('web/reset-password', {username: this.resetEmail})
				.then(response => {
					const self=this
					this.$swal({
						icon: 'success',
						title: 'Success!',
						text: 'An email was been sent to your email, Please check the reset link!',
						onClose(){
							self.$router.replace('/')
						}
					})
				})
				.catch(response => {
					if (response.status===422) {
						this.$swal({
							icon: 'error',
							title: 'Validation!',
							text: 'Please enter a valid email address!'
						})
					} else {
						this.$swal({
							icon: 'error',
							title: 'Oops!',
							text: 'Something wen\'t wrong!'
						})
					}
				})
		},


		onSubmit() {
			this.$refs.ValidatorLogin.validate()
				.then( success => {
					if(!success) {
						return;
					}

					this.$swal({
						text: 'Authenticating. . .',
						allowOutsideClick: false
					})
					this.$swal.showLoading()
					this.$http.post('login', {
						email: this.username,
						password: this.password,
					}).then( response => {
						// console.log(response)
						this.$store.commit('auth/user', response.data.user)
						this.$store.commit('auth/access_token', response.data)
						// console.log(this.$store.getters['auth/access_token'])
						// window.location.reload()
						const roles = response.data.user.roles.map(role => role.name);
						// this.$nextTick(() => {
						// 	this.$swal.close()
						// })

						if(roles.includes('member')) {
							window.location.href='/dashboard.html'
						} else {
							return Promise.reject('Roles is not defined');
						}
						
						
					}).catch( response => {
						console.log(response)
						this.$swal({
							icon: 'error',
							text: 'Invalid Credentials'
						})
					}).finally(() => {
						// this.$swal.hideLoading()
					})
				})
		}
	}
}
</script>

<style lang="scss" scoped>
	.login-box {
		min-width: 375px !important;
		min-height: 465px !important;
	}
</style>